var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show == true)?_c('div',{staticClass:"loader-f6db8wb6o2h"},[_c('span',{staticClass:"loader-f6db8wb6o2h-pf5phdynvda"},[_vm._v(_vm._s(_vm.text))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }